import { render, staticRenderFns } from "./VueEcharts.vue?vue&type=template&id=664163ab&scoped=true&"
import script from "./VueEcharts.vue?vue&type=script&lang=js&"
export * from "./VueEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664163ab",
  null
  
)

export default component.exports